import { useDispatch } from "react-redux";
import UpdateDeleteModal from "../../../globalComponents/Modals/UpdateDeleteModal/UpdateDeleteModal";
import { STUDENTS_MODAL_ACTION_TYPE } from "../../../redux/actions-type";
import {
  deleteStudentAction,
  updateStudentsAction,
} from "../../../redux/actions/studentsActions";
import moment from "moment";
import "moment/locale/az";
import { useCustomHook } from "../../../globalComponents/GlobalFunctions/globalFunctions";
import DeleteItemModal from "../../../globalComponents/Modals/DeleteItemModal/DeleteItemModal";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import StudentDiplomaStatusDropdown from "./StudentDiplomaStatusDropdown";

const StudentCard = ({
  data,
  mode,
  cellNumber,
  setOpenMoreModal,
  setOpenConfirmModal,
  student,
}) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { whereSendList } = useCustomHook();
  const [showDeleteModal, setShowDeleteModal] = useState(false);

  const whereSendName = whereSendList.find(
    (item) => item.key === data?.whereSend,
  )?.name;

  const [selected, setSelected] = useState({
    user: null,
    group: null,
  });


  const navigatePerformance = (user, group) => {
    setSelected({
      user,
      group,
    });
    navigate(`/student-performance/${user?._id}/${group?._id}`);
  };

  let courses =
    Array.isArray(data?.courses) && data?.courses.length > 0
      ? data.courses
          .map((course) => {
            return `${course.name}`;
          })
          .join(", ")
      : "";
  const listData = [
    { key: "İxtisas", value: courses },
    {
      key: "Mobil nömrə",
      value: data?.phone ? data?.phone : "",
    },
  ];

  const updateItem = (modalType) => {
    dispatch({
      type: STUDENTS_MODAL_ACTION_TYPE.GET_STUDENTS_MODAL,
      payload: {
        data: JSON.parse(JSON.stringify(data)),
        openModal: modalType !== "more" ? true : false,
      },
    });
  };

  // add near your other handlers
const handleDiplomaStatusChange = (newStatusKey, groupItem) => {
  const updatedGroups = data.groups.map((g) =>
    g.group._id === groupItem.group._id
      ? { ...g, certificateStatus: newStatusKey } // only this group changes
      : g // all other groups stay untouched
  );

  const updatedData = {
    ...data,
    groups: updatedGroups,
  };

  dispatch(updateStudentsAction(data._id, updatedData));
  // ^ replace with your real action name/signature
};
  const deleteItem = () => {
    dispatch(deleteStudentAction(data._id));
  };

  const openMoreModal = () => {
    updateItem("more");
    setOpenMoreModal(true);
  };

  const openConfirmModal = () => {
    dispatch({
      type: STUDENTS_MODAL_ACTION_TYPE.OPEN_STUDENT_CONFIRM_MODAL,
      payload: {
        data: data,
        openModal: false,
        confirmModal: true,
      },
    });
  };

  const doubleClick = () => {
    updateItem("");
  };

  // Tələbənin qrup sayı (minimum 1 sətir olsun deyə fallback)
  const groupsList =
    Array.isArray(data?.groups) && data?.groups.length > 0
      ? data.groups
      : [null]; // qrupu olmayan tələbə üçün boş sətir

  const rowSpanCount = groupsList.length;


  // console.log(groupsList[0]?.attendancePercentage,"group list")




  return (
    <>
      {showDeleteModal && (
        <DeleteItemModal
          setShowDeleteModal={setShowDeleteModal}
          deleteItem={deleteItem}
        />
      )}
      {mode === "desktop" ? (
        groupsList.map((groupItem, groupIndex) => (
          <tr
            key={groupItem?.group?._id || `${data._id}-${groupIndex}`}
            onDoubleClick={doubleClick}
          >
            {/* --- Tələbəyə aid ümumi məlumatlar, yalnız ilk sətirdə, rowSpan ilə --- */}
            {groupIndex === 0 && (
              <>
                <td rowSpan={rowSpanCount}>
                  <div className="td-con">
                    <div className="cell-number">{cellNumber}.</div>
                    <div
                      className="table-scroll-text"
                      style={{ padding: "0px" }}
                    >
                      {data?.fullName || ""}
                    </div>
                  </div>
                </td>
                <td rowSpan={rowSpanCount}>
                  <div className="td-con">
                    <div className="table-scroll-text">{data?.fin || ""}</div>
                  </div>
                </td>
                <td rowSpan={rowSpanCount}>
                  <div className="td-con">
                    <div className="table-scroll-text">{data?.seria || ""}</div>
                  </div>
                </td>
                <td rowSpan={rowSpanCount}>
                  <div className="td-con">
                    <div className="table-scroll-text">
                      {data?.birthday
                        ? moment(data.birthday)
                            .locale("az")
                            .format("DD MMMM YYYY ")
                        : "" || ""}
                    </div>
                  </div>
                </td>
                <td rowSpan={rowSpanCount}>
                  <div className="td-con">
                    <div className="table-scroll-text">{data?.phone || ""}</div>
                  </div>
                </td>
                <td rowSpan={rowSpanCount}>
                  <div className="td-con">
                    <div
                      className="table-scroll-text"
                      style={{ textTransform: "lowercase" }}
                    >
                      {data?.email || ""}
                    </div>
                  </div>
                </td>
                <td rowSpan={rowSpanCount}>
                  <div className="td-con">
                    <div className="table-scroll-text">
                      {data?.whereComing?.name || ""}
                    </div>
                  </div>
                </td>
                <td rowSpan={rowSpanCount}>
                  <div className="td-con">
                    <div className="table-scroll-text">
                      {whereSendName || ""}
                    </div>
                  </div>
                </td>
                <td rowSpan={rowSpanCount}>
                  <div className="td-con">
                    <div className="table-scroll-text">{data?.salesType}</div>
                  </div>
                </td>
                <td rowSpan={rowSpanCount}>
                  <div className="td-con">
                    <div className="table-scroll-text">{courses}</div>
                  </div>
                </td>
              </>
            )}

            {/* --- Qrup adı, hər sətirdə fərqli --- */}
            <td style={{paddingLeft:"12px"}}>
              <div className="td-con"  >
                <div className="table-scroll-text">
                  {groupItem?.group?.name || ""}
                </div>
              </div>
            </td>

            {/* --- Lab/Əsas sayları, hər qrupa görə ayrı sətirdə --- */}
            <td>
              <div className="td-con">
                <div className="table-scroll-text">
                  {/* Lab:{data?.practicsQbCount || 0} / Əsas:
                  {data?.mainQbCount || 0}/  */}
                  QB : {Math.round(groupItem?.attendancePercentage ?? 0)}%
                </div>
              </div>
            </td>
             <td className="pass">
              <div onClick={() => navigatePerformance(data, groupItem?.group)}>
                <div className="table-scroll-text">keçid</div>
              </div>
            </td>
             <td>
              <div className="td-con isdebtor">
                <div className="table-scroll-text">
                  {groupItem?.isDebtor ? "Borclu" : "Borc yoxdur"}
                </div>
              </div>
            </td>
          
            <td className="student-diploma-dropdown"  style={{ minWidth: "160px",position:"relative" }}>
              <div >
                <div >
                  <StudentDiplomaStatusDropdown
                    currentStatus={groupItem?.certificateStatus}
                    onChangeStatus={(newStatusKey) =>
                      handleDiplomaStatusChange(newStatusKey, groupItem)
                    }
                  />
                </div>
              </div>
            </td>
           

           

            {groupIndex === 0 && (
              <td rowSpan={rowSpanCount}>
                <UpdateDeleteModal
                  updateItem={updateItem}
                  deleteItem={deleteItem}
                  data={data}
                  setOpenConfirmModal={setOpenConfirmModal}
                  state={student}
                  openConfirmModal={openConfirmModal}
                  openMoreModal={openMoreModal}
                  profil="students"
                  setShowDeleteModal={setShowDeleteModal}
                  modelName="student"
                />
              </td>
            )}
          </tr>
        ))
      ) : (
        <div className="content-box">
          <div className="left">
            <h3>{data.fullName}</h3>
            <ul>
              {listData.map((item, index) => (
                <li key={index}>
                  <span className="type">{item.key}:</span>
                  <p>{item.value}</p>
                </li>
              ))}
            </ul>
            <div className="groups-list">
              <h2>Qruplar</h2>
              <ul>
                {data?.groups?.map((groupsData) => (
                  <li key={groupsData.group._id}>
                    <span>Qrup adı: {groupsData?.group?.name}</span>
                    Qrup İxtisası: {groupsData?.group?.course?.name} <br />
                    Ümumi ödəniş: {groupsData?.totalAmount} <br />
                  </li>
                ))}
              </ul>
            </div>
          </div>
          {student.power === "only-show" ? (
            <div className="more-content">
              <span onClick={openMoreModal}>Ətraflı</span>
            </div>
          ) : (
            <div className="right">{/* <UpdateDeleteModal ... /> */}</div>
          )}
        </div>
      )}
    </>
  );
};

export default StudentCard;
